import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  CatalogOptionsListRequest,
  CatalogOptionListResponse,
  FilterResponse,
  FilterValueRequest,
} from "../types/api/metadata";
import { CatalogResponse, CategoryResponse } from "../types/api/ads";

const path = `/metadata/admin/${process.env.REACT_APP_API_VERSION}`;
const pathFilterMetrics = `/monitoring/${process.env.REACT_APP_API_VERSION}/filters`;

export function fetchCatalogOptions(params: CatalogOptionsListRequest) {
  return mainAPI
    .get<CatalogOptionListResponse[]>(`${path}/options`, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data as CatalogOptionListResponse[],
          totalCount: countHeader,
        });
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Произошла ошибка")
        );
      }
    );
}

// Значения фильтра - Получить список стран
export function fetchCountries(params: FilterValueRequest) {
  return mainAPI.get(`${pathFilterMetrics}/country/values`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data as FilterResponse,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}

// Значения фильтра - Получить список городов
export function fetchCities(params: FilterValueRequest) {
  return mainAPI.get(`${pathFilterMetrics}/city/values`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data as FilterResponse,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}

// Значения фильтра - Получить список категорий
export function fetchCategories(params: { limit?: number; offset?: number }) {
  return mainAPI.get(`${path}/categories`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data as CategoryResponse[],
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}

// Значения фильтра - Получить список каталогов
export function fetchCatalogs(params: { limit?: number; offset?: number }) {
  return mainAPI.get(`${path}/catalogs`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data as CatalogResponse[],
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
